export enum SettingsActionTypes {
  UPDATE_SETTINGS = '@@settings/UPDATE_SETTINGS',
}

export interface OutputMap {
  pdfFileId: string;
  textFileId: string;
  documentType: string;
  pii: string;
  pagesDataExtraction: string;
  documentDataExtraction: string;
  dataExtractionV2: string;
  idPredictions: string;
  idCutOut: string;
  faceVerification: string;
  riskAssessment: string;
  fileId: string;
  mergedFileId: string;
  crossMatchResults: string;
}

export interface SettingsState {
  workflowId: string;
  endpoint: string;
  clientId: string;
  clientSecret: string;
  outputMap: OutputMap;
}

export interface SettingsStateOld {
  workflowId: string;
  endpoint: string;
  clientId: string;
  clientSecret: string;
  outputMap: OutputMap;
}
